<template>
  <span class="svg-ico-skills-domain-business">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.79387 7.335C20.18601 6.94616 20.81906 6.94873 21.20794 7.34087C21.59679 7.73301 21.59413 8.36606 21.20207 8.75494L13.77043 16.12504C13.57573 16.31794 13.31001 16.42243 13.03607 16.41411C12.76221 16.40571 12.50383 16.28533 12.32121 16.08111L8.93057 12.28423L4.18156 16.68853C3.77655 17.06379 3.1439 17.03974 2.76848 16.63483C2.39305 16.22983 2.41721 15.59721 2.82219 15.22174L8.31827 10.12603L8.39541 10.06157C8.58111 9.92117 8.81121 9.84934 9.04581 9.8604C9.31367 9.87317 9.56537 9.99249 9.74404 10.19246L13.11026 13.96196L19.79387 7.335Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
